import COS from "cos-js-sdk-v5";
import $ from 'jquery';

const retryUploadCosTime = 5
let reTryUploadVideoTimes = 0;
let reTryUploadVideoTimeout;
let reTryUploadJsonTimes = 0;
let reTryUploadJsonTimeout;
let reTryUploadWavTimes = 0;
let reTryUploadWavTimeout;
let reTryUploadTxtTimes = 0;
let reTryUploadTxtTimeout;
let sendToCos;

export class Cos {

    /**
     * 获取url参数值
     * @param name
     * @returns {*}
     */
    static uploadCos(recordBlob, args) {
        reTryUploadWavTimes = 0;
        clearTimeout(reTryUploadWavTimeout);
        reTryUploadTxtTimes = 0;
        clearTimeout(reTryUploadTxtTimeout);
        //录制音频参数
        const options = {
            Bucket: 'course-wavs-1256571289',
            Region: 'ap-beijing'
        }

        // 初始化实例
        let cos = Cos.getCosSignature();

        //上传至cos
        let cos_filePath = args.cid;
        let wav_fileName = `$${args.cosDate}$${args.putaoid}$${args.uuid}-web-main.wav`;
        let txt_fileName = `$${args.cosDate}$${args.putaoid}$${args.uuid}-web-main.txt`;
        let Key = cos_filePath + "/" + wav_fileName;
        let txtKey = cos_filePath + "/" + txt_fileName;
        //上传音频
        if (recordBlob) {
            let uploadWav = () => {
                reTryUploadWavTimes++;
                cos.putObject({
                    Bucket: options.Bucket,
                    Region: options.Region,
                    Key: Key,
                    Body: recordBlob,
                    onProgress: function (info) {
                        // console.log(JSON.stringify(info));
                    }
                }, function (err, data) {
                    if (data) {
                        reTryUploadWavTimes = 0;
                    }
                    if (err) {
                        let tryCallback = function () {
                            if (reTryUploadWavTimes < retryUploadCosTime) {
                                reTryUploadWavTimeout = setTimeout(() => {
                                    uploadWav();
                                }, 2000);
                            }
                        }
                        tryCallback();
                        // 自己的接口支持上传文本和视频有问题，先注掉
                        // if (args.userParamsStr) {
                        //     Cos.useSelfUpload(args.userParamsStr, options.Bucket, Key, recordBlob).then((res) => {
                        //         if (res && res.code === 200) {
                        //             // 上传成功
                        //         } else {
                        //             tryCallback();
                        //             Cos.handleErrorReport("mediaEx", `self upload audio fail:${Key}, info:${JSON.stringify(res)}`);
                        //         }
                        //     }).catch((error) => {
                        //         tryCallback();
                        //         Cos.handleErrorReport("mediaEx", `self upload audio catch:${Key}, info:${JSON.stringify(error)}`);
                        //     });
                        // } else {
                        //     tryCallback();
                        // }
                        Cos.handleErrorReport("mediaEx", `cos upload audio fail:${Key}, args:${JSON.stringify(sendToCos)}, info:${JSON.stringify(err)}`);
                    }
                });
            }
            uploadWav();
        }

        //上传txt
        if (args && args.result) {
            let uploadTxt = () => {
                reTryUploadTxtTimes++;
                cos.putObject({
                    Bucket: options.Bucket,
                    Region: options.Region,
                    Key: txtKey,
                    Body: args.result,
                    onProgress: function (info) {
                        // console.log(JSON.stringify(info));
                    }
                }, function (err, data) {
                    if (data) {
                        reTryUploadTxtTimes = 0;
                    }
                    if (err) {
                        let tryCallback = function () {
                            if (reTryUploadTxtTimes < retryUploadCosTime) {
                                reTryUploadTxtTimeout = setTimeout(() => {
                                    uploadTxt();
                                }, 2000);
                            }
                        }
                        tryCallback();
                        // 自己的接口支持上传文本和视频有问题，先注掉
                        // if (args.userParamsStr) {
                        //     Cos.useSelfUpload(args.userParamsStr, options.Bucket, txtKey, args.result).then((res) => {
                        //         if (res && res.code === 200) {
                        //             // 上传成功
                        //         } else {
                        //             tryCallback();
                        //             Cos.handleErrorReport("mediaEx", `self upload txt fail:${txtKey}, info:${JSON.stringify(res)}`);
                        //         }
                        //     }).catch((error) => {
                        //         tryCallback();
                        //         Cos.handleErrorReport("mediaEx", `self upload txt catch:${txtKey}, info:${JSON.stringify(error)}`);
                        //     });
                        // } else {
                        //     tryCallback();
                        // }
                        Cos.handleErrorReport("mediaEx", `cos upload txt fail:${txtKey}, args:${JSON.stringify(sendToCos)}, info:${JSON.stringify(err)}`);
                    }
                });
            }
            uploadTxt();
        }
    }

    static uploadVideoToCos(recordBlob, args) {
        reTryUploadVideoTimes = 0;
        clearTimeout(reTryUploadVideoTimeout);
        reTryUploadJsonTimes = 0;
        clearTimeout(reTryUploadJsonTimeout);
        //录制音频参数
        const options = {
            Bucket: 'courses-replay-1256571289',
            Region: 'ap-beijing'
        }

        // 初始化实例
        let cos = Cos.getCosSignature();

        //上传至cos
        let cos_filePath = `pc/${args.cid}/${args.putaoid}/${args.startTime}`;
        let video_fileName = `${args.curPage}.webm`;
        let json_fileName = `${args.curPage}.json`;
        let Key = cos_filePath + "/video/" + video_fileName;
        let jsonKey = cos_filePath + "/json/" + json_fileName;
        //上传video
        if (recordBlob) {
            let uploadVideo = () => {
                reTryUploadVideoTimes++;
                cos.putObject({
                    Bucket: options.Bucket,
                    Region: options.Region,
                    Key: Key,
                    Body: recordBlob,
                    onProgress: function (progressData) {
                        if (progressData.percent === 1) {
                            console.log('v');
                        }
                    }
                }, function (err, data) {
                    if (data) {
                        reTryUploadVideoTimes = 0;
                    }
                    if (err) {
                        let tryCallback = function () {
                            if (reTryUploadVideoTimes < retryUploadCosTime) {
                                reTryUploadVideoTimeout = setTimeout(() => {
                                    uploadVideo();
                                }, 2000);
                            }
                        }
                        tryCallback();
                        // 自己的接口支持上传文本和视频有问题，先注掉
                        // if (args.userParamsStr) {
                        //     Cos.useSelfUpload(args.userParamsStr, options.Bucket, Key, recordBlob).then((res) => {
                        //         if (res && res.code === 200) {
                        //             // 上传成功
                        //         } else {
                        //             tryCallback();
                        //             Cos.handleErrorReport("mediaEx", `self upload webm fail:${Key}, info:${JSON.stringify(res)}`);
                        //         }
                        //     }).catch((error) => {
                        //         tryCallback();
                        //         Cos.handleErrorReport("mediaEx", `self upload webm catch:${Key}, info:${JSON.stringify(error)}`);
                        //     });
                        // } else {
                        //     tryCallback();
                        // }
                        Cos.handleErrorReport("mediaEx", `cos upload webm fail:${Key}, args:${JSON.stringify(sendToCos)}, info:${JSON.stringify(err)}`);
                    }
                });
            }
            uploadVideo();
        }

        //上传json
        if (args && args.result) {
            let jsonResult = JSON.parse(args.result);
            if (recordBlob) {
                jsonResult.m3u8Url = `https://courses-replay-1256571289.cos.ap-beijing.myqcloud.com/${cos_filePath}/video/${args.curPage}.m3u8`;
            }
            let uploadJson = () => {
                reTryUploadJsonTimes++;
                cos.putObject({
                    Bucket: options.Bucket,
                    Region: options.Region,
                    Key: jsonKey,
                    Body: JSON.stringify(jsonResult),
                    onProgress: function (info) {
                        // console.log(JSON.stringify(info));
                    }
                }, function (err, data) {
                    if (data) {
                        reTryUploadJsonTimes = 0;
                    }
                    if (err) {
                        let tryCallback = function () {
                            if (reTryUploadJsonTimes < retryUploadCosTime) {
                                reTryUploadJsonTimeout = setTimeout(() => {
                                    uploadJson();
                                }, 2000);
                            }
                        }
                        tryCallback();
                        // 自己的接口支持上传文本和视频有问题，先注掉
                        // if (args.userParamsStr) {
                        //     Cos.useSelfUpload(args.userParamsStr, options.Bucket, jsonKey, JSON.stringify(jsonResult)).then((res) => {
                        //         if (res && res.code === 200) {
                        //             // 上传成功
                        //         } else {
                        //             tryCallback();
                        //             Cos.handleErrorReport("mediaEx", `self upload json fail:${jsonKey}, info:${JSON.stringify(res)}`);
                        //         }
                        //     }).catch((error) => {
                        //         tryCallback();
                        //         Cos.handleErrorReport("mediaEx", `self upload json catch:${jsonKey}, info:${JSON.stringify(error)}`);
                        //     });
                        // } else {
                        //     tryCallback();
                        // }
                        Cos.handleErrorReport("mediaEx", `cos upload json fail:${jsonKey}, args:${JSON.stringify(sendToCos)}, info:${JSON.stringify(err)}`);
                    }
                });
            }
            uploadJson();
        }
    }

    /**
     * args.userParamsStr {String}   用户验签信息，需要拼成字符串（用 utils.setJsonToUrl 方法）
     */
    static uploadImageToCos(fileOrImageBase64, args, callback, failCallback) {
        reTryUploadVideoTimes = 0;
        clearTimeout(reTryUploadVideoTimeout);
        const options = {
            Bucket: 'course-app-1256571289',
            Region: 'ap-beijing'
        }

        // 初始化实例
        let cos = Cos.getCosSignature(args.userParamsStr);

        //上传至cos
        let cos_filePath = args.cos_filePath || `dillgentplan/users/`;
        let image_fileName = `${args.putaoid}_${args.startTime}_${args.type}.jpg`;
        let Key = cos_filePath + image_fileName;
        //上传image
        if (fileOrImageBase64) {
            let uploadImage = () => {
                reTryUploadVideoTimes++;
                cos.putObject({
                    Bucket: options.Bucket,
                    Region: options.Region,
                    Key,
                    Body: fileOrImageBase64,
                    onProgress: function (progressData) {
                        if (progressData.percent === 1) {
                            console.log('v');
                        }
                    }
                }, function (err, data) {
                    //data 请求成功时返回的对象，如果请求发生错误，则为空
                    let tryCallback = function () {
                        if (reTryUploadVideoTimes < retryUploadCosTime) {
                            reTryUploadVideoTimeout = setTimeout(() => {
                                uploadImage();
                            }, 1000);
                        } else {
                            failCallback && typeof failCallback === "function" && failCallback(err);
                        }
                    }
                    let successCallback = function () {
                        if (callback && typeof callback === "function") {
                            if (args.cos_prefix) {
                                callback(args.cos_prefix + Key + '?imageMogr2/auto-orient');
                            } else {
                                callback(`https://course-app-1256571289.cos.ap-beijing.myqcloud.com/${Key}`);
                            }
                        }
                    }
                    if (data) {
                        reTryUploadVideoTimes = 0;
                        successCallback();
                    }
                    if (err) {
                        if (args.userParamsStr) {
                            Cos.useSelfUpload(args.userParamsStr, options.Bucket, Key, fileOrImageBase64).then((res) => {
                                if (res && res.code === 200) {
                                    successCallback();
                                } else {
                                    tryCallback();
                                    Cos.handleErrorReport("imgLoadEx", `self upload image fail:${Key}, info:${JSON.stringify(res)}`);
                                }
                            })
                                .catch((error) => {
                                    tryCallback();
                                    Cos.handleErrorReport("imgLoadEx", `self upload image catch:${Key}, info:${JSON.stringify(error)}`);
                                });
                        } else {
                            tryCallback();
                        }

                        Cos.handleErrorReport("imgLoadEx", `cos upload image fail:${Key}, args:${JSON.stringify(sendToCos)}, info:${JSON.stringify(err)}`);
                    }
                });
            }
            uploadImage();
        }
    }

    // 上传失败以后尝试用自己的上传
    // cType：1-文件；2-字符串
    static useSelfUpload(userParamsStr, Bucket, Key, Body) {
        let data = new FormData(), cType;
        if (typeof Body === "string") {
            data.append("string", Body);
            cType = 2;
        } else {
            data.append("file", Body);
            cType = 1;
        }
        Cos.handleErrorReport("imgLoadEx", `use /sogouSE/tx/upload:${Key}, cType:${cType}`);
        return fetch(`/sogouSE/tx/upload?${userParamsStr}&bn=${encodeURIComponent(Bucket)}&path=${encodeURIComponent(Key)}&ctype=${cType}`, {
            method: "POST",
            body: data
        }).then(res => res.json());
    }

    // 获取前面等信息
    static getCosSignature(userParamsStr) {
        const cosSignatureUrl = `/course/live/get_secret?${userParamsStr || "putaoid=6F856B20-E9CF-40E5-993B-50D94882A5A6&sign=bdbb2b4f911f0e14ab953a3609d7042f&ts=1539762402&uuid=6F856B20-E9CF-40E5-993B-50D94882A5A6"}`;
        return new COS({
            getAuthorization: function (options, callback) {
                // 异步获取签名
                $.get(cosSignatureUrl, {
                    bucket: options.Bucket,
                    region: options.Region,
                }, function (json) {
                    if (json && json.data && json.data.credentials) {
                        let data = json.data;
                        sendToCos = {
                            TmpSecretId: data.credentials.tmpSecretId,
                            TmpSecretKey: data.credentials.tmpSecretKey,
                            XCosSecurityToken: data.credentials.sessionToken,
                            ExpiredTime: data.expiredTime
                        };
                        json.startDateTime && (sendToCos.StartTime = json.startDateTime);
                        callback(sendToCos);
                    } else {
                        if (json && json.code && json.code === 300) {
                            Cos.getCosSignature();
                        }
                        Cos.handleErrorReport("apiSucEx", `get cos sign fail:${cosSignatureUrl}, info:${JSON.stringify(json)}`);
                    }
                });
            }
        });
    }

    // 错误上报
    static handleErrorReport(type, stack) {
        try {
            window.PTMonitor.report({
                type: type,
                url: window.location.href,
                time: new Date().getTime(),
                stack: stack
            }, window.EX_TYPE[type]);
        } catch (error) { }
    }
}



// WEBPACK FOOTER //
// ./src/lib/Cos.js